<template>
  <div class="main">
    <van-dialog
      v-model:show="showDialog"
      show-cancel-button
      @confirm="launchApp"
      @cancel="() => (userId = '')"
    >
      <div class="tan">
        <van-field
          v-model="userId"
          label-width="5em"
          label-align="center"
          label="工号:"
          placeholder="请输入您的工号"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { qywechatloginApplets } from "@/api/common";
import { getPartnerAccessToken, refreshPartnerAccessToken } from "@/api/fkw";
import { getUrlParams } from "@/utils/index";
import { setStorage } from "@/utils/storage";

export default {
  data() {
    return {
      userId: "",
      nickName: "",
      // userId: "12003038",
      showFooter: true,
      showDialog: false,
      tokenObj: null,
      options: {
        fromHdportalM: true,
        url: process.env.VUE_APP_QYWEIXIN_ANNUAL_METTING_GAMES2023_URL,
        partner_access_token: "",
      },
    };
  },
  beforeRouteEnter: (to, from, next) => {
    const code = getUrlParams("code") || "";
    if (process.env.NODE_ENV === "development") {
      next();
      return;
    }

    if (!code) {
      location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd054cb5d9acc03cd&redirect_uri=${encodeURIComponent(
          process.env.VUE_APP_QYWEIXIN_ANNUAL_METTING_GAMES2023_REDIRECT_URL
        )}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`
      );
      return;
    }
    next();
  },
  computed: {
    url({ options }) {
      if (!options.partner_access_token) {
        return "";
      }
      let tempUrl = decodeURIComponent(options.url);
      Object.keys(options)
        .filter((item) => item !== "url")
        .forEach((item) => {
          tempUrl +=
            (tempUrl.indexOf("?") !== -1 ? "&" : "?") +
            item +
            "=" +
            options[item];
        });
      return tempUrl;
    },
  },
  watch: {
    url(value) {
      if (value) {
        location.replace(value);
      }
    },
  },
  created() {
    const nv = navigator.userAgent;
    if (nv.includes("Windows")) {
      this.showFooter = false;
      this.$dialog.alert({ message: "请使用手机企业微信App打开！" });
      return;
    }
    if (this.userId) {
      return this.launchWebview();
    } else {
      this.goWeixin();
    }
  },
  mounted() {
    document.title = "慕思新年集福";
  },
  methods: {
    goWeixin() {
      const code = getUrlParams("code") || "";
      const params = {
        code,
        appId: process.env.VUE_APP_QYWEIXIN_ANNUAL_METTING_GAMES2023_AGENT_ID,
        systemCode:
          process.env.VUE_APP_QYWEIXIN_ANNUAL_METTING_GAMES2023_SYSTEM_CODE,
      };
      qywechatloginApplets(params).then((res) => {
        if (res.code == 0) {
          this.userId = res?.data?.account;
          this.nickName = res?.data?.nickName;
          this.launchWebview();
        } else {
          this.$dialog.alert({ message: "获取小程序链接失败！" + res.msg });
        }
      });
    },
    async launchWebview() {
      const tempOptions = {};
      this.options = {
        ...this.options,
        ...tempOptions,
        partner_access_token: await this.getToken(),
      };
    },
    async getToken() {
      if (!this.tokenObj?.access_token) {
        this.tokenObj = await getPartnerAccessToken({
          auth_uid: this.userId,
          // auth_uid_name: this.nickName,
          // auth_uid_head: "https://derucci-app-test-obs.iderucci.com/upload/20231218/5349eddbd00e8e55184294bba4f0b66d.png",
        }).then((res) => res.data);
        this.tokenObj.expiresTime =
          Date.now() + this.tokenObj.expires_in * 1000;
      } else {
        const isExpires =
          this.tokenObj.expiresTime &&
          new Date().getTime() > new Date(this.tokenObj.expiresTime).getTime();
        if (isExpires) {
          this.tokenObj = await refreshPartnerAccessToken({
            refresh_token: this.tokenObj.refresh_token,
            // auth_uid_name: this.nickName,
            // auth_uid_head: "https://derucci-app-test-obs.iderucci.com/upload/20231218/5349eddbd00e8e55184294bba4f0b66d.png",
          })
            .then((res) => res.data)
            .catch(async () =>
              getPartnerAccessToken({
                auth_uid: this.userId,
                // auth_uid_name: this.nickName,
                // auth_uid_head: "https://derucci-app-test-obs.iderucci.com/upload/20231218/5349eddbd00e8e55184294bba4f0b66d.png",
              }).then((res) => res.data)
            );
          this.tokenObj.expiresTime =
            Date.now() + this.tokenObj.expires_in * 1000;
        }
      }
      setStorage("fkwtokenObj", this.tokenObj);
      return this.tokenObj.access_token;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.van-button--primary) {
  background-color: #e53f3f;
  border-color: #e53f3f;
  border-radius: 8px;
  color: #ffedca;
  padding: 0 50px;
}
:deep(.van-cell__value) {
  border-bottom: 1px solid #969799;
}
.tan {
  padding: 50px 30px;
}
.main {
  min-height: 100vh;
  .logo {
    padding-top: 50px;
    text-align: center;
    p {
      font-size: 14px;
    }
  }
  .btn {
    text-align: center;
    padding-top: 500px;
    padding-bottom: 100px;

    p {
      font-size: 12px;
      color: #e04241;
    }
  }
}
.footer {
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  color: #999;
  font-size: 11px;
}

/* 横屏 */
@media screen and (orientation: landscape) {
  .footer {
    display: none;
  }
}
</style>
